import {
  EVLocationOnOutlinedIcon,
  EVListItemIcon,
  EVListItemText,
  EVSvgIcon,
} from 'lib/components';
import React from 'lib/react';
import PropTypes from 'prop-types';

function LocationOnOutlinedIcon() { return <EVLocationOnOutlinedIcon viewBox="0 0 24 24" />; }

/**
 * Component to display autocomplete suggestion list items.
 */
function LocationTemplate(props) {
  const { option } = props;

  return (
    <>
      <EVListItemIcon style={{ minWidth: 0 }}>
        <EVSvgIcon component={LocationOnOutlinedIcon} viewBox="0 0 52 52" />
      </EVListItemIcon>
      <EVListItemText primary={option.address1} secondary={option.address2} />
    </>
  );
}

LocationTemplate.propTypes = {
  option: PropTypes.shape().isRequired,
};

export default LocationTemplate;
